import clsx from 'clsx';
import { MktSpinnerSizes, MktSpinnerTypes } from './Spinner.types';

export const MktSpinnerStrokeStyles = {
  [MktSpinnerTypes.PRIMARY]: 'whl-stroke-primary',
  [MktSpinnerTypes.SECONDARY]: 'whl-stroke-secondary',
};

export const MktSpinnerDimensionStyles = {
  [MktSpinnerSizes.SMALL]: clsx('whl-w-4', 'whl-h-4'),
  [MktSpinnerSizes.MEDIUM]: clsx('whl-w-6', 'whl-h-6'),
  [MktSpinnerSizes.BIG]: clsx('whl-w-12', 'whl-h-12'),
};
